export const FILE_EXTENSION = {
  PDF: 'pdf',
  PNG: 'png',
  JPEG: 'jpeg',
  JPG: 'jpg',
  MP3: 'mp3',
  MP4: 'mp4',
  XLSX: 'xlsx',
  XLSM: 'xlsm'
};

export const LAYOUTS = {
  EMPLOYEES: 'Layouts/Layout_Empleados.xlsm',
  CATALOGO: 'Layouts/Layout-catalogo.xlsx',
};